import { createStore } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { SemanticSearchStore } from './semantic_search.store.types';
import { createSemanticSearchSlice } from './semanticSearchSlice';
import { ISemanticSearchApiService } from '../services/semanticSearchApiService';

export type SemanticSearchStoreType = ReturnType<typeof createSemanticSearchStore>;

export interface SemanticSearchStoreDependencies {
    api: ISemanticSearchApiService;
}

export const createSemanticSearchStore = ({ api }: SemanticSearchStoreDependencies) => {
    return createStore<SemanticSearchStore>()(
        immer((...a) => ({
            ...createSemanticSearchSlice(api)(...a),
        }))
    );
};